<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">Many people have worked very hard to bring this book together. Graduate students Clint Alley, Jesse Brock, and Wesley Garmon, who are all part of the University of North Alabama Public History graduate program, did the bulk of the scanning, research, and photography when we could not find historical images of important places in and around Florence. Without their hard work, this book would not have been possible.</p>
<p class="para">I would also like to thank Louise Huddleston, the archivist at the Collier Library Archives and Special Collections at the University of North Alabama, for her hard work and patience as this project has gone forward. A thank-you goes to Judy Sizemore, director of the Muscle Shoals National Heritage Area, for her advice and participation in the project. Nancy Sanford, the director of the Florence-Lauderdale Public Library, graciously allowed access to the library’s digital archives and also allowed her employees to assist in this project. A thank-you is also given to Lee Freeman of the Florence-Lauderdale Public Library for all of the information he shared with us about Florence. Thanks go to Florence Main Street for its help on this project and for letting us use images from its annual calendars. I would also like to give thanks to Falon Yates for her help with the photography. And a big thank-you is owed to Vince Brewton for sending this project my way.</p>
<p class="para">I would also like to thank Jesse Darland, Lydia Rollins, and Jason Humphrey of Arcadia Publishing for all of their help during this process.</p>
<p class="para">The images in this volume appear courtesy of the University of North Alabama Collier Library Archives and Special Collections (UNA), the Florence Lauderdale Public Library (FLPL), and Florence Main Street (FMS).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?6bc4521b